<template>
  <div class="addTipsComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="row">
      <div class="formulario col-sm-6 col-md-10">
        <v-form ref="form" lazy-validation class="mt-5 col-sm-10 col-md-6">
          <v-text-field
            :outlined="false"
            :filled="false"
            :solo="false"
            :label="'*'+$t('tips.label.form.categoryName')" 
            :placeholder="$t('tips.label.form.categoryNamePlaceholder')" 
            :counter="50"
            :maxlength="50"
            required
            :rules="categoryNameRules"
            v-model="formData.happinessCategoryTipsName"
            class="linea-inferior-pura"
          ></v-text-field>

          <v-select
            v-model="formData.status"
            :label="$t('tips.label.form.status')"
            :items="listStatus"
            item-text="nameStatus"
            item-value="valueStatus"
            :outlined="false"
            :filled="false"
            :solo="false"
            required
            class="mt-5 linea-inferior-pura"
          ></v-select>
        </v-form>
      </div>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            fixed
            bottom
            right
            dark
            large
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="submitForm"
          >
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('button.save') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event_bus.js";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';

import {
  TIPS_M,
  GET_STATE_LOADING,
  GET_TIPS,
  ACTION_PUT_UPDATE_TIPS,
} from "@/views/tips-categories/store/types/types.js";

import Swal from "sweetalert2";
export default {
  name: "detailTipsComponent",
  props: {
    tips: {
      required: true,
    },
  },
  data() {
    return {
      formData: {
        tipId: this.tips?.happinessCategoryTipsId || null,
        happinessCategoryTipsName: this.tips?.happinessCategoryTipsName || "",
        status: this.tips?.status !== undefined ? this.tips.status : true,
      },
      listStatus: [
        {
          idStatus: 1,
          nameStatus: this.$t('novelties.label.status.option1'),
          valueStatus: true
        },
        {
          idStatus: 2,
          nameStatus: this.$t('novelties.label.status.option2'),
          valueStatus: false
        }
      ],
      categoryNameRules: [
        v => !!v || i18n.t('tips.label.form.categoryNameRequired'),
        v => (v && v.length >= 3) || i18n.t('tips.label.form.categoryNameMinLength'),
        v => (v && v.length <= 50) || i18n.t('tips.label.form.categoryNameMaxLength'),
        v => !this.allTips.some(t => t.happinessCategoryTipsName && t.happinessCategoryTipsName.toLowerCase() === v.toLowerCase() && t.happinessCategoryTipsId !== this.tips.happinessCategoryTipsId) || i18n.t('tips.label.form.categoryNameDuplicate'),
      ],
      showErrorMessages: false,
    };
  },

  computed: {
    ...mapGetters({
      loading: [`${TIPS_M}${GET_STATE_LOADING}`],
      allTips: `${TIPS_M}${GET_TIPS}`,
    }),
  },

  methods: {
    ...mapActions({
      putActionUpdateTips: `${TIPS_M}${ACTION_PUT_UPDATE_TIPS}`,
    }),

    async submitForm() {
      try {
        const result = await Swal.fire({
          title: i18n.t('label.confirm.title'),
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: i18n.t('button.save.text'),
          cancelButtonText: i18n.t('button.cancel.text'),
          confirmButtonColor: '#6E17A5'
        });
        if (result.isConfirmed) {

          const validationErrors = this.validateForm();

          if (Object.keys(validationErrors).length > 0) {
            const errorMessages = Object.values(validationErrors).join("<br>");
            Swal.fire({
              icon: 'error',
              title: i18n.t('label.errorsValidation.plural.title'),
              html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
              confirmButtonColor: '#6E17A5'
            });
            return;
          }

          const save = await this.putActionUpdateTips(this.formData);
          if (!save) {
            return Swal.fire({
              icon: 'error',
              title: i18n.t('label.invalid.title'),
              text: i18n.t('label.invalid.text')
            });
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "info",
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500,
          });
        }
        EventBus.$emit("reload-update-tips");
      } catch (error) {
        console.error(i18n.t('label.failService'));
      }
    },

    validateForm() {
      this.showErrorMessages = true;
      const errors = {};

      if (!this.formData.happinessCategoryTipsName || !this.formData.happinessCategoryTipsName.trim() || this.formData.happinessCategoryTipsName.length < 3 || this.formData.happinessCategoryTipsName.length > 50) {
          errors.happinessCategoryTipsName = this.$t('tips.label.form.categoryName');
      }

      return errors;
    },
  },
};
</script>

<style lang="css" scoped>
.formulario {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5vw;
}

.row {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 425px) {
  .formulario {
    gap: 10px;
    display: flex;
    flex-direction: column-reverse;
  }
}

.linea-inferior-pura ::v-deep fieldset {
  display: none !important;
  border: none !important;
}

.linea-inferior-pura ::v-deep .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.linea-inferior-pura.v-input--is-focused ::v-deep .v-input__slot {
  border-bottom: 2px solid #6e17a5 !important;
}
</style>
